import { useLiquidateAllController } from "./LiquidateAllPositions.controller";
import {
  LiquidateAllConfirmationPresentation,
  LiquidateAllSectionPresentation,
} from "./LiquidateAllPositions.pres";

export interface LiquidateAllPositionsProps {
  active: boolean;
  positionCount: number;
  liquidatedCount: number;
  isLoadingPositions: boolean;
  positionsErrorMessage?: string;
  isPending: boolean;
  isSuccess: boolean;
  errorMessage?: string;
  onRetryPositions: () => void;
  liquidate: (options: { cancelOrders: boolean }) => void;
  disabled?: boolean;
  onRequestLiquidate: () => void;
  onBack: () => void;
}

export const LiquidateAllPositions = ({
  active,
  positionCount,
  liquidatedCount,
  isLoadingPositions,
  positionsErrorMessage,
  isPending,
  isSuccess,
  errorMessage,
  onRetryPositions,
  liquidate,
  disabled,
  onRequestLiquidate,
  onBack,
}: LiquidateAllPositionsProps) => {
  const { cancelOrders, setCancelOrders, onSubmit } = useLiquidateAllController(
    {
      active,
      onConfirm: liquidate,
    },
  );

  if (!active) {
    return (
      <LiquidateAllSectionPresentation
        positionCount={positionCount}
        isLoadingPositions={isLoadingPositions}
        positionsErrorMessage={positionsErrorMessage}
        onRetryPositions={onRetryPositions}
        disabled={disabled}
        onRequestLiquidate={onRequestLiquidate}
      />
    );
  }

  return (
    <LiquidateAllConfirmationPresentation
      positionCount={positionCount}
      liquidatedCount={liquidatedCount}
      cancelOrders={cancelOrders}
      isPending={isPending}
      isSuccess={isSuccess}
      errorMessage={errorMessage}
      onCancelOrdersChange={setCancelOrders}
      onSubmit={onSubmit}
      onBack={onBack}
    />
  );
};
